<header class="header">
  <nav class="navbar-container">
    <div class="navbar-brand-container">
      <a href="/" class="navbar-brand">
        <img src="assets/logos/loansLogo.png" alt="loansLogo" width="150px" />
      </a>
    </div>
  </nav>
</header>
